import { View } from "binder"
import { AddNewPropertyViewModel } from "./addNewProperty-viewModel"

export class AddNewPropertyView extends View<AddNewPropertyViewModel>{
    GetViewUniqueId(): string {
        return "V-67A62851-BC33-4ECD-8024-CE4A83292D9D"
    }
    loadHtml(): string {
        let element = require('./addNewProperty.html').default;
        let style = require('./addNewProperty.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isAttr(v: boolean) {  this._isAttr = v; } public get isAttr(): boolean { return this._isAttr;} private _isAttr: boolean;
    public set isAttribute(v: boolean) { this._isAttribute = v; } public get isAttribute(): boolean { return this._isAttribute;} private _isAttribute: boolean;
    public set isEvent(v: boolean) {  this._isEvent = v; } public get isEvent(): boolean { return this._isEvent;} private _isEvent: boolean;
    public set isClass(v: boolean) {  this._isClass = v; } public get isClass(): boolean { return this._isClass;} private _isClass: boolean;
    public set isHtml(v: boolean) {  this._isHtml = v; } public get isHtml(): boolean { return this._isHtml;} private _isHtml: boolean;
    public set attrValue(v: string) { this._attrValue = v; } public get attrValue(): string { return this._attrValue;} private _attrValue: string;
    public set attributeValue(v: string) { this._attributeValue = v; } public get attributeValue(): string { return this._attributeValue;} private _attributeValue: string;
    public set eventValue(v: string) { this._eventValue = v; } public get eventValue(): string { return this._eventValue;} private _eventValue: string;
    public set classValue(v: string) { this._classValue = v; } public get classValue(): string { return this._classValue;} private _classValue: string;
    public set htmlValue(v: string) { this._htmlValue = v; } public get htmlValue(): string { return this._htmlValue;} private _htmlValue: string;
    public set classSuggestions(v: string[]) { this._classSuggestions = v; } public get classSuggestions(): string[] { return this._classSuggestions;} private _classSuggestions: string[];

    confirm(){
        this.dataContext.confirm();
    }

    close(){
        this.dataContext.close();
    }
}
